import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-icon-maintenance',
  templateUrl: './icon-maintenance.component.html',
  styleUrls: ['./icon-maintenance.component.scss']
})
export class IconMaintenanceComponent implements OnInit {

  @Input() cssClass = 'icon--18';

  constructor() { }

  ngOnInit() {
  }

}
